<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">Virtual Account - Add/Edit Form
          </div>
          <b-input-group>
            <b-input-group-prepend><label>Trx. Id</label></b-input-group-prepend>
            <div v-if="(this.disableInput)" class="form-control-static">{{ frmdata.trx_id }}</div>
            <b-form-input v-else v-model="frmdata.trx_id"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Virtual Account</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.virtual_account" :state="!$v.frmdata.virtual_account.$error"></b-form-input>
          </b-input-group>
          <div slot="footer" style="text-align:center;">
            <button class="btn btn-primary mr-1" @click="inquiry()">
              <i class="fa fa-save"></i> Inquiry
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()"> <i class="fa fa-close"></i> Close
              Form</b-button>
          </div>
        </b-card>


        <b-card>
          <div slot="header" class="text-center">RESULT
          </div>
         
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss">
.input-group {
  padding-bottom: 2px;

  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 100px;
    }
  }
}
</style>


<script>
import toastr from "mini-toastr";
import ecollection from "../../apis/ecollection"
import moment from "moment"
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      // nasabahkey: {
      //   required: requiredIf(function () {
      //     return this.disableInput
      //   })
      // },
      // pinjamankey: {
      //   required: requiredIf(function () {
      //     return this.disableInput
      //   })
      // },
      customer_name: { required },
      customer_email: { required },
      customer_phone: { required },
      trx_amount: { required },
      billing_type: { required },
      virtual_account: { required },
      datetime_expired: { required },
    },
  },
  data() {
    return {
      frmdata: {
        trx_id: '',
        trx_amount: 0,
        billing_type: 'n',
        billing_type_desc: '',
        customer_name: '',
        customer_email: '',
        customer_phone: '',
        virtual_account: '',
        datetime_expired: moment().add(1, 'month').format('DD/MM/YYYY HH:mm'),
        description: '',
        nasabahkey: '',
        pinjamankey: '',
        pjxkey: '',
      },
      result:{}
    };
  },
  computed: {
    
  },
  watch: {
  },
  created: async function () {
  },
  methods: {
    billingTypeCase(expression) {
      let text = ''
      switch (expression) {
        case 'o':
          text = 'Open Payment (o)'
          break;
        case 'c':
          text = 'Fixed payment (c)'
          break;
        case 'i':
          text = 'Installment/Partial Payment (i)'
          break;
        case 'm':
          text = 'Minimum Payment (m)'
          break;
        case 'n':
          text = 'Open Minimum Payment (n)'
          break;
        default:
          text = 'Open Maximum Payment (x)'
        // code block
      }

      return text;
    },
    inquiry: async function () {
      try {
        const { data } = await ecollection.inqury(this.frmdata)
        if (data.status == '000') {
          toastr.success(data.message);
        } else {
          toastr.error(data.message);
        }
      } catch (error) {
        toastr.error(error);
      }
    },
    close() {
      router.push("home");
    },
  }
};
</script>
